function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "calendar"
}, /*#__PURE__*/React.createElement("path", {
  d: "m19 4h-1v-1c0-.552-.447-1-1-1s-1 .448-1 1v1h-8v-1c0-.552-.447-1-1-1s-1 .448-1 1v1h-1c-1.654 0-3 1.346-3 3v12c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-12c0-1.654-1.346-3-3-3zm-14 2h14c.552 0 1 .449 1 1v2h-16v-2c0-.551.448-1 1-1zm14 14h-14c-.552 0-1-.449-1-1v-8h16v8c0 .551-.448 1-1 1z"
}));

var Svg023Calendar = function Svg023Calendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg023Calendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/023-calendar.613a88d9.svg";
export { ForwardRef as ReactComponent };